import type { PaginatedResponse } from '../interfaces/api';

/**
 * @description Recorre todas las páginas de un endpoint paginado y devuelve los elementos de todas ellas concatenados.
 */
export const fetchAllPages = async <T>(
  fetchPage: (page: number) => Promise<PaginatedResponse<T>>
): Promise<T[]> => {
  const firstPage = await fetchPage(1);

  if (firstPage.meta.last_page <= 1) {
    return firstPage.data;
  }

  const remainingPages = await Promise.all(
    Array.from({ length: firstPage.meta.last_page - 1 }, (_, index) => fetchPage(index + 2))
  );

  return [firstPage, ...remainingPages].flatMap((page) => page.data);
};
